import { CREATE_USER_PHONE_REQUEST, CREATE_USER_PHONE_SUCCESS, CREATE_USER_PHONE_FAILURE } from '../../constants/user_phones.constants';

export const createUserPhoneRequest = (id, phone, name) => ({
    type: CREATE_USER_PHONE_REQUEST, id, phone, name,
});
export const createUserPhoneRequestSuccess = payload => ({ type: CREATE_USER_PHONE_SUCCESS, payload });
export const createUserPhoneRequestFailure = error => ({ type: CREATE_USER_PHONE_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/actions/user_phones_actions/create_user_phone.actions.js